<template>
  <article class="article">
    <div class="content" :class="inFeed ? 'feed-item '+orientation : orientation ">
      <div v-if="published" class="published container">
        <div class="row">
          <div class="col-4 cover-image" :style="'background: url(' + (article.image != null ? article.image : '/static/placeholders/placeholder-logo.jpg') + ') center center; background-size: cover;'"></div>

          <div class="col-8 inner-content">
            <div class="row">
              <div class="date col-6">{{ articleDate }}</div>
              <div class="article-type col-6 float-right">
                <i class="fa" :class="getIconForArticleType(article.articleType.name)"></i>
              </div>
            </div>
            <p class="article-type">{{ $t('label.' + article.articleType.name) }}</p>
            <h4 v-if="article.author" class="author">{{ article.author.name + ' ' + article.author.surname }}</h4>
            <h3 class="title">
              <router-link :to="{name: 'article', params: {slug: translation.slug}}" v-if="translation.slug !== ' '">{{ translation.title }}</router-link>
              <router-link :to="{name: 'articleById', params: {id: article.id}}" v-else>{{ translation.title }}</router-link>
            </h3>
            <div class="video" v-if="article.articleType.name === 'video'">{{ translation.body }}</div>
            <p class="body">{{ translation.description }}</p>
            <router-link :to="{name: 'article', params: {slug: translation.slug}}" class="btn btn-secondary" v-if="translation.slug !== ' '">{{ $t('button.read_all') }}</router-link>
            <router-link :to="{name: 'articleById', params: {id: article.id}}" class="btn btn-secondary" v-else>{{ $t('button.read_all') }}</router-link>
          </div>
        </div>
      </div>

      <div v-else class="unpublished">
        <div class="subtitle text-center">{{ $t('label.publish_date') }}</div>
        <div class="date text-center">{{ articleDate }}</div>
        <div class="article-type-icon text-center">
          <i class="fa" :class="getIconForArticleType(article.articleType.name)" aria-hidden="true"></i>
        </div>
        <p class="article-type text-center">{{ $t('label.' + article.articleType.name) }}</p>
        <h3 class="title text-center">
          {{ translation.title }}
        </h3>
        <p class="text-center">{{ translation.description }}</p>
      </div>
    </div>
    <div class="line" :class="orientation" v-if="inFeed">
      <span class="theLine"></span>
    </div>
  </article>
</template>

<script>
export default {
  name: 'ArticleCard',

  props: {
    article: {
      type: Object,
      required: true
    },
    orientation: {
      validator: function (value) {
        return value === 'left' || value === 'right'
      },
      default() {
        return 'left'
      }
    },
    published: {
      type: Boolean,
      default: false
    },
    inFeed: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    translation: function () {
      return this.article.articleTranslations[0]
    },
    articleDate: function () {
      return this.formatDate(this.article.publishDate)
    }
  }

}
</script>

<style lang="scss" scoped>
@import "~styles/_vars.scss";

.article {
  padding: 0;
  position: relative;

  * {
    transition: all 0.2s;
  }

  .content {
    position: relative;
    display: block;
    box-sizing: border-box;
    border-radius: 0.4rem;
    background: $white;
    box-shadow: $drop-shadow-card;
    z-index: 100;
    overflow: hidden;

    &.left {
      border-left: 8px solid $primary-color;
    }

    &.right {
      border-right: 8px solid $primary-color;
    }

    &.feed-item {
      width: 95%;

      &.left {
        float: left;
      }
      &.right {
        float: right;
      }
    }

    &:hover {}
  }

  .line {
    display: inline-block;
    position: absolute;
    width: 5%;
    height: 51%;

    &.left {
      float: right;
      border-right: 1px solid $feed-line-color;
    }
    &.right {
      float: left;
      border-left: 1px solid $feed-line-color;
      margin-left: -1px;
    }

    .theLine {
      position: absolute;
      top: 100%;
      display: block;
      width: 100%;
      margin-top: -1px;
      height: 1px;
      background: $feed-line-color;
    }
  }

  .article-type {
    text-align: right;
    color: $light-gray;
    font-size: 1.6rem;
    line-height: 1;
  }

  p.article-type {
    text-align: left;
    font-size: 0.75rem;
    margin: 0 0 1rem 0;
    text-transform: uppercase;
    color: $txt-color-secondary;
    letter-spacing: 3px;
  }

  &:hover {
    .line {
      z-index: 1000;
    }

    .theLine {
      background: $primary-color;
    }

    .content {
      top: -1px;
      box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
    }
  }

  @media (max-width: $device-sm) {
    .content.feed-item {
      width: 100%;
    }

    .line {
      display: none;
    }
  }
}

.inner-content {
  padding: 1.5rem;
}

.date {
  color: $txt-color-secondary;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 3px;
  margin-bottom: 3.75rem;

  @media(max-width: $device-sm) {
    margin-bottom: 2rem;
  }
}

.title,
.title>a {
  position: relative;
  color: $txt-color-heading;
  font-weight: $bold;
  font-size: 1.5rem;
  margin-bottom: 0.75rem;
  z-index: 100;
  line-height: 1.4;
}

.author {
  font-size: 1.2rem;
  font-weight: $semibold;
  margin-top: 2rem;
  color: $txt-color-secondary;
}

.bg {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background-size: cover;
  z-index: 0;

  .bg-overlay {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.3);
  }
}

.body {
  color: $txt-color-primary;
  margin-bottom: 2.5rem;
}

.btn-secondary {
  background: $secondary-color;
  border: none;
  color: $white;
  text-transform: uppercase;
  font-size: 0.9rem;
  font-weight: bold;
  padding: 0.8rem 2rem;

  &:hover {
    background: darken($secondary-color, 10%);
  }
}

.subtitle {
  color: $txt-color-secondary;
  font-size: 0.75rem;
  letter-spacing: 3px;
  text-transform: uppercase;
}

.published,
.unpublished {
  width: 100%;
}

.unpublished {
  padding: 1.5rem;

  .date {
    font-size: 1rem;
    font-weight: $semibold;
    margin-bottom: 0;
  }

  .article-type-icon {
    font-size: 10rem;
    color: $light-gray;
  }
}
</style>



// WEBPACK FOOTER //
// ArticleCard.vue?45314660